export const MARKET_RATES_HERO_LABEL = '30yr conv · week-over-week';

export const MARKET_RATES_PMMS_SOURCE = 'Freddie Mac PMMS';

export const MARKET_RATES_COMPLIANCE_NOTE =
  'Rate changes are market observations, not a quote or commitment.';
